$(document).ready(function (e) {
    window.addEventListener('popstate', function (event) {
        window.location.href = window.history.back();
    });

  if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
    $("html").addClass("os-ios");
    $("#reviews-iframe").attr("scrolling", "no");
    $("#reviews-iframe").css("height", "100%");

    $("#main-tertiary-content").css("z-index","99");

  } else {
    $("#reviews-iframe").css("height", "800");
  }

  function openonmobile () {
    if($('.feefowidget-container-content__accordion-btn').length) {
      $('.feefowidget-container-content__accordion-btn').click();
    } else if ($('.feefowidget-global-container-body-content-controls').length){
      //
    } else {
      setTimeout(openonmobile, 50);
    }
  }

  openonmobile()
});
